import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import moment from 'moment';

import { ChatEntry } from '../../_models/models';
import { IRootState } from '../../store/_root.reducer';
import { clearChat, clearSystemChat, setZoom } from '../../store/game.reducer';
import { sendChatMessage } from '../../store/output.reducer';

import './chat.scss';
import { insertSuits } from '../../_utils/helper';

export interface IChatProps extends StateProps, DispatchProps {}

export const Chat: FunctionComponent<IChatProps> = props => {
    const { t } = useTranslation();
    const chatContainer = useRef<HTMLDivElement>(null);
    const [message, setMessage] = useState('');
    const [isDirectorMessage, setIsDirectorMessage] = useState(false);
    const [lastChatEntry, setLastChatEntry] = useState<ChatEntry | undefined>(undefined);
    const { app, game } = props;
    const { chat } = game;
    const textAreaRef = useRef<HTMLTextAreaElement>(null);

    const resizeTextarea = () => {
        const el = textAreaRef.current;
        if (!el) return;
        el.style.height = 'auto';
        el.style.height = `${el.scrollHeight}px`;
    };

    useEffect(() => {
        const _lastCHatEntry = game.chat[game.chat.length - 1];
        if (_lastCHatEntry !== lastChatEntry) {
            setLastChatEntry(_lastCHatEntry);
            if (chatContainer.current) {
                chatContainer.current.scrollTop = chatContainer.current.scrollHeight;
            }
        }
        // setTimeout(() => {
        //     props.clearSystemChat();
        // }, 30000);
    }, [game.chat]);

    const sendMessage = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (message) {
            const chatEntry: ChatEntry = {
                sender: app.user || 'unknown',
                timestamp: moment.utc().format(),
                message
            };
            props.sendChatMessage({ ...chatEntry, isDirectorMessage });
            setMessage('');
            setIsDirectorMessage(false);

            if (textAreaRef.current) {
                textAreaRef.current.style.height = 'auto';
            }
        }
    };

    return (
        <section className={`Chat`}>
            <div className="chat" ref={chatContainer}>
                {chat.map((chatEntry, index) => {
                    const isZoomLink = chatEntry.message.startsWith('https://') && chatEntry.message.includes('zoom.us/j/');
                 //   console.log("Chat Message: ",chatEntry.message, isZoomLink);
                    return (
                        !!chatEntry && (
                            <div
                                key={`${chatEntry.sender}-${chatEntry.timestamp}-${index}`}
                                className={`chatEntry ${chatEntry.sender === app.user ? 'isMe' : ''}`}
                            >
                                {isZoomLink ? (
                                    <>
                                        <header>
                                            <div className="sender">Join audio/video via Zoom App</div>
                                        </header>
                                        <a href={chatEntry.message} target="_blank"  onClick={() => {
                                            //console.log('Zoom link clicked');
                                            props.setZoom(undefined);
                                            // any extra action here
                                        }}
                                           style={{
                                               display: 'inline-block',
                                               padding: '10px 16px',
                                               background: '#2d6cdf',
                                               color: 'white',
                                               textDecoration: 'none',
                                               borderRadius: '8px',
                                               fontWeight: 600,
                                               cursor: 'pointer',
                                           }}
                                        >Click here to open Zoom</a>
                                    </>
                                ) : (
                                    <>
                                    <header>
                                        <div className="sender">{chatEntry.sender}</div>
                                        <div className="time">{moment(chatEntry.timestamp).format('HH:mm')}</div>
                                    </header>
                                    <div className="text" dangerouslySetInnerHTML={{ __html: insertSuits(chatEntry.message) }} />
                                    </>
                                )}
                            </div>
                        )
                    );
                })}
            </div>
            {game.showChatSendForm && (
                <form onSubmit={sendMessage} className="sendMessage">
                    <div className="input">
                        <textarea
                            ref={textAreaRef}
                            value={message}
                            rows={1}
                            onChange={e => {
                                setMessage(e.target.value);
                                resizeTextarea();
                            }}
                            onKeyDown={e => {
                                if (e.key === 'Enter' && !e.shiftKey) {
                                    e.preventDefault();
                                    const form = e.currentTarget.form;
                                    if (form) form.requestSubmit();
                                }
                            }}
                            placeholder={t(`chat.${isDirectorMessage ? 'typeDirectorMessage' : 'typeMessage'}`)}
                        />
                    </div>
                    {message ? <button type="submit" /> : <button type="button" onClick={() => props.clearChat()} />}
                    {message ? (
                        <button
                            type="submit"
                            className={`toggleDirectorMessage`}
                            onClick={() => setIsDirectorMessage(!isDirectorMessage)}
                        />
                    ) : (
                        <button
                            type="button"
                            className={`toggleDirectorMessage ${isDirectorMessage && 'isDirectorMessage'}`}
                            onClick={() => setIsDirectorMessage(!isDirectorMessage)}
                        />
                    )}
                </form>
            )}
        </section>
    );
};

const mapStateToProps = ({ app, game }: IRootState) => ({
    app,
    game
});

const mapDispatchToProps = {
    sendChatMessage,
    clearChat,
    clearSystemChat,
    setZoom
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(Chat);
